import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';

const ColumnToggleTable = ({
  setShowTableColumns,
  columnsData,
  columnVisibility,
  setColumnVisibility,
  dropdownRef,
}) => {
  const [localColumnVisibility, setLocalColumnVisibility] = useState(columnVisibility);

  useEffect(() => {
    setLocalColumnVisibility(columnVisibility);
  }, [columnVisibility]);

  const toggleColumn = (columnKey) => {
    setLocalColumnVisibility((prevVisibility) => {
      const updatedVisibility = {
        ...prevVisibility,
        [columnKey]: !prevVisibility[columnKey],
      };

      const selectedColumnCount = Object.values(updatedVisibility).filter(Boolean).length;

      if (selectedColumnCount >= 3) {
        return updatedVisibility;
      } else {
        toast.error('At least 3 columns must be selected.');
        return prevVisibility;
      }
    });
  };

  const handleApplyFilter = () => {
    const selectedColumnCount = Object.values(localColumnVisibility).filter(Boolean).length;
    if (selectedColumnCount >= 3) {
      setColumnVisibility(localColumnVisibility);
      setShowTableColumns(false);
    } else {
      toast.error('At least 3 columns must be selected before applying the filter.');
    }
  };

  return (
    <div className="card position-absolute top-0 end-0 mt-2 me-2 table-columns w-25" ref={dropdownRef}>
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Table Columns</h5>
      </div>
      <div className="card-body">
        <Row className="g-3">
          {columnsData.map(({ key, header }) => (
            <Col lg={6} key={key}>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div>{header}</div>
                <div>
                  <Form.Check
                    type="switch"
                    id={`column-toggle-${key}`}
                    checked={localColumnVisibility[key]}
                    onChange={() => toggleColumn(key)}
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
      <div className="card-footer">
        <Button
          variant=""
          className="login-btn base-color-bg fs-15 text-white fw-semibold ms-auto"
          onClick={handleApplyFilter}
        >
          Apply Filter
        </Button>
      </div>
    </div>
  );
};

export default ColumnToggleTable;
